import { GetReceivedItemsVm } from './get-received-items.vm';
import { CallbackObject } from 'api/core/get-page-function';
import { plainToClass } from 'class-transformer';
import { AxiosResponse } from 'axios';
import { instance } from 'api/core';

export const getReceivedItems = async (reception: string, offset: string, callback: CallbackObject<GetReceivedItemsVm>) => {
  const config: Record<string, any> = {
    headers: {
      'Content-Type': 'application/json',
    },
    params: {
      limit: 50,
      offset: offset,
    },
  };

  try {
    const res: AxiosResponse = await instance.get(`/reception/receptions/${reception}/items`, config);
    callback.success(plainToClass(GetReceivedItemsVm, res.data));
  } catch (err) {
    if (callback.error) callback.error(err);
  }
};
